<script setup>
/**
 * FormControlMRegistrantsRegistrantsUsername
 * Composition-based wrapper around the standard text form control.
 * Evaluates global organizational configuration flags on mount, contextually
 * dropping its layout visibility if usernames are set to be hidden system-wide.
 */
import { computed, onMounted, getCurrentInstance } from 'vue';
import FormControlTypeText from '../form-control-type/FormControlTypeText.vue';

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

/**
 * References global settings registries to check if the username
 * configuration should be omitted from customer management views.
 */
const isHidden = computed(() => {
    return !!store.state.settings?.config?.hide_customers_username_field;
});

// --- Lifecycle ---

onMounted(() => {
    /**
     * Contextual visibility guard: If global configuration blocks usernames,
     * drop visibility from the active orchestration form layer instantly.
     */
    if (isHidden.value && props.field) {
        props.field.hidden = true;
    }
});
</script>

<template>
    <FormControlTypeText
        v-if="!field.hidden"
        v-bind="$props"
        v-on="$listeners"
    />
</template>

<style scoped>
/* Presentation and sizing properties are inherited directly from FormControlTypeText */
</style>